<mat-spinner style="margin:50% auto;" strokeWidth="5" diameter="70"></mat-spinner>
